import axios from 'axios' 
import { BUSCAR_RESERVAS_REPASSE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import moment from 'moment';
import { tipoRepasseVenda } from '../../util/constantsUtil';
import { abaRepasseVenda } from '../../util/constantsUtil';

export default function buscarReservasRepasse (dataInicio = null, dataFim = null, tipo = tipoRepasseVenda.empresa.nome, aba = abaRepasseVenda.pendenteRepasse, vendedorId = null, empresaId = null, grupo = null, repasseId) {
  let url = `${URL}/repasse-venda/site/reservas?aba=${aba}`;

  if(tipo != null) {
    url = `${url}&tipo=${tipo}`
  }

  if (dataInicio != null && dataFim != null) {
    url = `${URL}/repasse-venda/site/reservas?dataInicio=${moment(dataInicio)
      .format('YYYY-MM-DD')}&dataFim=${moment(dataFim)
      .format('YYYY-MM-DD')}&tipo=${tipo}&aba=${aba}`;
  }

  if (vendedorId) {
    url += `&vendedorId=${vendedorId}`;
  }

  if (empresaId) {
    url += `&empresaId=${empresaId}`
  }

  if (grupo) {
    url += `&grupo=${grupo}`
  }
  
  if(repasseId != null) {
    url = `${url}&idRepasse=${repasseId}`
  }
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_RESERVAS_REPASSE,
        payload: response
      })
  );
}